type ButtonProps = {
  id?: string;
  className?: string;
  name?: string;
  type?: "button" | "submit" | "reset";
  style?: {};
  value?: string;
  isDisbled?: boolean;
  title?: string;
  icon?: undefined;
  loader?: undefined;
  onClick?: () => void;
  useDefaultClass?: boolean;
};

const FormButton = ({
  id,
  className,
  name,
  type = "button",
  style = {},
  value,
  isDisbled = false,
  title = "",
  icon,
  loader,
  onClick,
  useDefaultClass = true,
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`${
        useDefaultClass
          ? "w-full p-4 text-base md:text-[20px] font-outfit font-medium leading-4 text-center bg-skyblue md:hover:bg-skyblue/50 text-black  accent-[#11B1C9] shadow-[0px_4px_4px_0px_#01D9FF40] transition-all hover:opacity-90 duration-300 rounded-full"
          : ""
      }  ${className}`}
      style={style}
      type={type}
      name={name}
      id={id}
      disabled={isDisbled}
      title={title}
    >
      <span>{icon ? icon : ""}</span>
      {value}
    </button>
  );
};

export default FormButton;
